import {
  faFileChartPie,
  faUserDoctor,
} from "@fortawesome/pro-regular-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";

const NavigationHeader = () => {
  const { setPageDisplayed } = useContext(AppContext);
  const { setIsMobileDrawerOpen } = useContext(ExamCreatorContext);

  return (
    <div
      className="caseListHeaderButtonContainer"
      style={{
        width:
          navigator.userAgent.indexOf("Windows") > -1
            ? "calc(100% - 36px)"
            : "calc(100% - 20px",
      }}
    >
      <button
        className="caseListHeaderButton secondaryButton"
        onClick={() => setPageDisplayed("accountSettings")}
      >
        <FontAwesomeIcon
          icon={faUserDoctor}
          className="caseListHeaderButtonIcon"
        />
        My Account
      </button>
      <button
        className="caseListHeaderMobileButton secondaryButton"
        onClick={() => setPageDisplayed("accountSettings")}
      >
        <FontAwesomeIcon
          icon={faUserDoctor}
          className="caseListHeaderButtonIcon"
        />
      </button>
      <button
        className="caseListHeaderBurgerButton secondaryButton"
        onClick={setIsMobileDrawerOpen}
      >
        <FontAwesomeIcon icon={faBars} className="caseListHeaderButtonIcon" />
      </button>
    </div>
  );
};

export default NavigationHeader;
